module.exports = __webpack_public_path__ + "img/face-sunglasses.3005109f.svg";